export interface ILoanApplicationDocumentsKeyParams {
  applicationID?: string;
  documentID?: string;
}

export const loanApplicationDocumentsKeys = {
  root: (params: ILoanApplicationDocumentsKeyParams) =>
    ['loanApplicationDocuments', params.applicationID] as const,
  document: (params: ILoanApplicationDocumentsKeyParams) =>
    [...loanApplicationDocumentsKeys.root(params), params.documentID, 'document'] as const,
};

export function parseLoanApplicationDocumentsKeys<
  T extends keyof typeof loanApplicationDocumentsKeys
>(queryKey: ReturnType<(typeof loanApplicationDocumentsKeys)[T]>) {
  const [, applicationID, documentID] = queryKey;
  return { applicationID, documentID };
}
